module.exports = __webpack_public_path__ + "static/media/add_caf.02ca29ec.png";